
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class UpdateTaskDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('UpdateTaskDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  onCancel() {
    console.log('UpdateTaskDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onNo() {
    console.log('UpdateTaskDialog: onNo()'); // eslint-disable-line no-console

    this.dialog = false;

    this.$emit('no');
  }

  async onYes() {
    console.log('UpdateTaskDialog: onYes()'); // eslint-disable-line no-console

    this.dialog = false;

    this.$emit('yes');
  }
}
